import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import {
  Box
} from '@mui/material';

import WorkflowTester from './components/processing/WorkflowTester';


const SchoolProcessorV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Parse current URL to determine selected workflow
  const getCurrentWorkflow = useCallback(() => {
    const path = location.pathname;
    const workflowPath = path.split('/workflow/')[1];
    return workflowPath ? workflowPath.toUpperCase() : null;
  }, [location.pathname]);
  
  const [selectedWorkflow, setSelectedWorkflow] = useState(getCurrentWorkflow());

  // Update state when URL changes
  useEffect(() => {
    const newWorkflow = getCurrentWorkflow();
    if (newWorkflow !== selectedWorkflow) {
      setSelectedWorkflow(newWorkflow);
    }
  }, [location.pathname, selectedWorkflow, getCurrentWorkflow]);

  const handleWorkflowSelection = (workflow) => {
    if (workflow) {
      const workflowPath = workflow.toLowerCase();
      navigate(`/admin/school-processor/workflow/${workflowPath}`);
    } else {
      navigate('/admin/school-processor/workflow');
    }
  };



  const renderWorkflowMode = () => {
    return (
      <WorkflowTester 
        selectedWorkflow={selectedWorkflow}
        onWorkflowSelect={handleWorkflowSelection}
      />
    );
  };

  return (
    <Box>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/school-processor/workflow" replace />} />
        <Route path="/workflow" element={renderWorkflowMode()} />
        <Route path="/workflow/:workflow" element={renderWorkflowMode()} />
      </Routes>
    </Box>
  );
};

export default SchoolProcessorV2; 